import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SlCheckbox from '@shoelace-style/shoelace/dist/react/checkbox/index.js';
import type { IntegrationSettingsFormProps } from './integrationForms';

const MarketplaceSettings = ({ settings, onChange }: IntegrationSettingsFormProps) => {
	const { t } = useTranslation();

	useEffect(() => {
		if (settings.sendOriginalImages === undefined) {
			onChange({ ...settings, sendOriginalImages: true }); // default to true
		}
	}, [settings, onChange]);

	return (
		<div className='integration__settings'>
			<SlCheckbox
				checked={settings.sendOriginalImages ?? true}
				onSlChange={(e: any) =>
					onChange({ ...settings, sendOriginalImages: e.target.checked })
				}
			>
				{t('Send original photos')}
				<span className='integration__option-hint'>
					{t(
						'Send your original photo, in its own proportions, as the main image. Otherwise the processed square photo is sent.',
					)}
				</span>
			</SlCheckbox>
		</div>
	);
};

export { MarketplaceSettings };
